import script from "./NewsCardsSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCardsSlide.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__